import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getClientById } from "../api/clientApi";
import ClientDocuments from "../components/ClientDocuments";
import ClientServiceSubscription from "../components/ClientServiceSubscription";


const ClientProfile = () => {
  const { id } = useParams();

  const [client, setClient] = useState(null);
  const [tab, setTab] = useState("overview");

  useEffect(() => {
    loadClient();
  }, [id]);

  const loadClient = async () => {
    try {
      const res = await getClientById(id);
      setClient(res.data);
    } catch (err) {
      console.error("Failed to load client", err);
    }
  };

  if (!client) return <p>Loading...</p>;

  return (
    <div className="space-y-6">

      {/* Header */}
<div className="flex justify-between items-center mb-4">

  <h2 className="text-xl font-semibold">
    {client?.ClientCode} : {client?.ClientName}
  </h2>

  

</div>


      {/* Tabs */}
      <div className="flex gap-4 border-b pb-2">
        {["overview", "contacts", "documents", "Assignment"].map(t => (
          <button
            key={t}
            onClick={() => setTab(t)}
            className={`capitalize ${
              tab === t
                ? "font-bold border-b-2 border-indigo-600"
                : "text-slate-500"
            }`}
          >
            {t}
          </button>
        ))}
      </div>

      {/* Overview */}
        {tab === "overview" && (
          <div className="bg-white p-6 rounded shadow space-y-2">
            <p><strong>Constitution:</strong> {client.EntityName || "-"}</p>
            <p><strong>PAN:</strong> {client.PAN || "-"}</p>
            <p><strong>GSTIN:</strong> {client.GSTIN || "-"}</p>
            <p><strong>Address:</strong></p>
            <p>{client.AddressLine1}</p>
            <p>{client.AddressLine2}</p>
            <p>{client.AddressLine3}</p>
            <p>{client.Area}</p>
            <p>{client.City} - {client.Pincode}</p>
            <p>{client.State}</p>
          </div>
        )}

      {/* Contacts */}
      {tab === "contacts" && (
        <div className="bg-white p-6 rounded shadow">
          Contacts Coming Soon
        </div>
      )}

      {/* Documents */}
      {tab === "documents" && (
        <div className="bg-white p-6 rounded shadow">
          <ClientDocuments clientId={id} />
        </div>
      )}

            {/* Services */}
      {tab === "services" && (
        <div className="bg-white p-6 rounded shadow">
          <ClientServiceSubscription />
        </div>
      )}

    </div>
  );
};

export default ClientProfile;
